// Re-export the shared hasPermission helper so channel-roi pages only need one import
export { hasPermission } from './crmPermissions';

export const CHANNEL_ROI_PERMISSIONS = {
  // Channel partner cooperation status
  PARTNER_READ: 'crm.channel_partner:read',
  PARTNER_UPDATE: 'crm.channel_partner:update',

  // Contacts
  CONTACT_READ: 'channel_roi.contact:read',
  CONTACT_CREATE: 'channel_roi.contact:create',
  CONTACT_DELETE: 'channel_roi.contact:delete',

  // Lead sources
  LEAD_SOURCE_READ: 'channel_roi.lead_source:read',
  LEAD_SOURCE_CREATE: 'channel_roi.lead_source:create',

  // Activities
  ACTIVITY_READ: 'channel_roi.activity:read',
  ACTIVITY_CREATE: 'channel_roi.activity:create',
  ACTIVITY_UPDATE: 'channel_roi.activity:update',
  ACTIVITY_DELETE: 'channel_roi.activity:delete',

  // Costs
  COST_READ: 'channel_roi.cost:read',
  COST_CREATE: 'channel_roi.cost:create',

  // Evaluations
  EVALUATION_READ: 'channel_roi.evaluation:read',
  EVALUATION_CREATE: 'channel_roi.evaluation:create',
  EVALUATION_UPDATE: 'channel_roi.evaluation:update',

  // Commission items
  COMMISSION_READ: 'channel_roi.commission:read',
  COMMISSION_CREATE: 'channel_roi.commission:create',
  COMMISSION_UPDATE: 'channel_roi.commission:update',
} as const;

export type ChannelRoiPermission =
  (typeof CHANNEL_ROI_PERMISSIONS)[keyof typeof CHANNEL_ROI_PERMISSIONS];
